// make our action generators utility functions for ease of use. Practically there is no difference between
// this method and just calling dispatch({ type: '', payload: {} }) with the appropriate values
const hoverRemoveApartmentAction = payload => {
    return { type: 'HOVER_REMOVE_APT', payload };
};

export default hoverRemoveApartmentAction;


// WEBPACK FOOTER //
// ./src/actions/hoverRemoveApartmentAction.js